import update from "immutability-helper";
import type { Dispatch, FC, SetStateAction } from "react";
import { useCallback } from "react";

import { Card } from "./DraggableCard";

export interface Item {
  id: number;
  imageUrl: string;
}

export interface ContainerState {
  cards: Item[];
}

export const Container: FC<{
  previews?: string[];
  urls?: string[];
  disabled?: boolean;
  removeFile?: (index: number, image_url: string) => void;
  setPreviews: Dispatch<SetStateAction<string[]>>;
}> = ({ previews, urls, disabled, removeFile, setPreviews }) => {
  const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
    setPreviews((prevCards: string[]) => {
      return update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex] as string],
        ],
      });
    });
  }, []);

  const renderCard = useCallback(
    (card: string, index: number) => {
      return (
        <Card
          key={card}
          url={card}
          disabled={disabled}
          removeFile={removeFile}
          index={index}
          moveCard={moveCard}
        />
      );
    },
    [previews]
  );
  return (
    <>
      <div className="border-2 rounded-lg mt-3">
        <h1 className="text-gray-600 text-center pt-3 px-3 text-sm">
          <span className="text-orange-500 font-medium text-base">
            {" "}
            Arrastrá
          </span>{" "}
          la imagen para cambiar el orden
        </h1>
        <h2 className="text-center text-xs text-gray-600 mt-1 font-normal px-3">
          La primera imagen (de izquierda a derecha) será utilizada como imagen
          principal{" "}
        </h2>
        <div className=" w-full mx-auto grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-x-2 gap-y-4  rounded-lg px-2  py-4 ">
          {previews.map((card, i) => {
            return renderCard(card, i);
          })}
        </div>
      </div>
    </>
  );
};
